import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-4xl mx-auto p-6 sm:p-8 pb-20" }
const _hoisted_2 = { class: "text-2xl font-bold mb-6 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_4 = { class: "w-12 h-12 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center" }
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = { class: "flex items-center gap-x-2" }
const _hoisted_7 = { class: "font-semibold text-base sm:text-lg text-gray-800" }
const _hoisted_8 = { class: "text-gray-600 mt-2 text-sm sm:text-base leading-snug text-justify whitespace-pre-line" }
const _hoisted_9 = {
  key: 1,
  class: "text-center text-gray-500"
}
const _hoisted_10 = {
  key: 2,
  class: "flex justify-center mt-6 space-x-2"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["disabled"]

import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useReservationStore } from "@/stores/reservationStore";

const pageSize = 5;


export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationList',
  setup(__props) {

const route = useRoute();
const side = route.params.side as string;
const store = useReservationStore();

const currentPage = ref(1);
const totalPages = computed(() => {
  return Math.ceil(store.reservations.length / pageSize);
});

const paginatedReservations = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  return store.reservations.slice(start, start + pageSize);
});

onMounted(() => {
  store.fetchReservations(side);
});

watch(
  () => route.params.side,
  (newSide) => {
    store.fetchReservations(newSide as string);
    currentPage.value = 1; // reset ke halaman 1 saat ganti side
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " Reservation List (" + _toDisplayString(_unref(side)) + ") ", 1),
    (paginatedReservations.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedReservations.value, (reservation, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: reservation.id || index,
              class: "flex items-start gap-4 p-4 border border-gray-200 rounded-xl shadow-sm bg-white"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'user'],
                  class: "text-gray-500 text-xl"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(reservation.name), 1),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _unref(store).getStatusIcon(reservation.status),
                    class: _normalizeClass([{
                'text-green-500': reservation.status === 'hadir',
                'text-red-500': reservation.status === 'tidak_hadir',
                'text-orange-500': reservation.status === 'ragu',
              }, "text-xl sm:text-2xl"])
                  }, null, 8, ["icon", "class"])
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(reservation.message), 1)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_9, "No reservations yet.")),
    (totalPages.value > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "px-3 py-1 rounded bg-gray-200 hover:bg-gray-300",
            disabled: currentPage.value === 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (currentPage.value--))
          }, " Prev ", 8, _hoisted_11),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
            return (_openBlock(), _createElementBlock("button", {
              key: page,
              onClick: ($event: any) => (currentPage.value = page),
              class: _normalizeClass([
          'px-3 py-1 rounded',
          currentPage.value === page
            ? 'bg-blue-600 text-white'
            : 'bg-gray-100 hover:bg-gray-200',
        ])
            }, _toDisplayString(page), 11, _hoisted_12))
          }), 128)),
          _createElementVNode("button", {
            class: "px-3 py-1 rounded bg-gray-200 hover:bg-gray-300",
            disabled: currentPage.value === totalPages.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value++))
          }, " Next ", 8, _hoisted_13)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})